import React from "react";
import { useNavigate } from "react-router-dom";
import { Image } from "react-bootstrap";
import { useAtomValue } from "jotai";

import "./UserAvatar.scss";
import useAuth from "../../hooks/useAuth";
import { ROUTES } from "../../utils/constants";
import DefaultAvatar from "../../images/fallback-avatar.png";
import Skeleton from "../Skeleton/Skeleton";
import { userCustomAvatarAtom } from "../../jotai/atoms/user";

export default function UserAvatar() {
  const navigate = useNavigate();
  const { userProfile } = useAuth();
  const userCustomAvatar = useAtomValue(userCustomAvatarAtom);
  const avatar = userCustomAvatar || userProfile?.avatar?.url;

  return (
    <Skeleton isLoading={!userProfile} width={32} height={32}>
      <button
        className="px-0 rounded-avatar"
        onClick={() => navigate(ROUTES.ROOT.PROFILE)}
      >
        {avatar ? (
          <Image src={avatar} alt="avatar" />
        ) : (
          <Image src={DefaultAvatar} alt="default-avatar" />
        )}
      </button>
    </Skeleton>
  );
}
